import React from "react";
import { useMsal } from "@azure/msal-react";

// Material Dashboard 2 React layouts
import Training from "layouts/SharpWatchLayouts/training";
import AdvTraining from "layouts/SharpWatchLayouts/advTraining";
import LeakEventResponseForm from "layouts/SharpWatchLayouts/leakEventForm";
import PreStartupForm from "layouts/SharpWatchLayouts/preStartupForm";
import EventResponseFlowChart from "layouts/SharpWatchLayouts/eventResponseFlowChart";
import SignOut from "layouts/authentication/Example Auth/sign-out";
import SignIn from "layouts/authentication/sign-in";
import ProtectedPage from "layouts/SharpWatchLayouts/ProtectedPage";
import Scenarios from "layouts/SharpWatchLayouts/scenarios";

// @mui icons
import Icon from "@mui/material/Icon";

function RoutesList() {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const userRoles = account?.idTokenClaims?.roles || [];

  // Start with an empty array
  let routes = [];

  // Shen - access to just pdfs (all users should have this as a baseline role)
  // ShenREG - access to regular training
  // ShenADv - access to advanced training
  // Add Advanced Training first if the user has an ADV role
  if (userRoles.some((role) => ["WhoDatADV"].includes(role))) {
    routes.push({
      type: "collapse",
      name: "Advanced Training",
      key: "advTraining",
      icon: <Icon fontSize="small">psychology</Icon>,
      route: "/advTraining",
      component: (
        <ProtectedPage allowedRoles={["WhoDatADV"]}>
          <AdvTraining />
        </ProtectedPage>
      ),
    });
  }

  // Add the remaining routes
  if (userRoles.some((role) => ["WhoDatREG"].includes(role))) {
    routes.push({
      type: "collapse",
      name: "Training",
      key: "training",
      icon: <Icon fontSize="small">school</Icon>,
      route: "/training",
      component: (
        <ProtectedPage allowedRoles={["WhoDatREG"]}>
          <Training />
        </ProtectedPage>
      ),
    });
  }
  // Add the remaining routes
  if (userRoles.some((role) => ["WhoDatREG"].includes(role))) {
    routes.push({
      type: "collapse",
      name: "Scenarios",
      key: "scenarios",
      icon: <Icon fontSize="small">pinInvoke</Icon>,
      route: "/scenarios",
      component: (
        <ProtectedPage allowedRoles={["WhoDatREG", "WhoDatADV"]}>
          <Scenarios />
        </ProtectedPage>
      ),
    });
  }
  routes.push(
    {
      type: "collapse",
      name: "Leak Event Form",
      key: "leakEventForm",
      icon: <Icon fontSize="small">description</Icon>,
      route: "/leakEventForm",
      component: (
        <ProtectedPage allowedRoles={["WhoDat", "WhoDatREG", "WhoDatADV"]}>
          <LeakEventResponseForm />
        </ProtectedPage>
      ),
    },
    {
      type: "collapse",
      name: "Pre Startup Form",
      key: "preStartupForm",
      icon: <Icon fontSize="small">restart_alt</Icon>,
      route: "/preStartupForm",
      component: (
        <ProtectedPage allowedRoles={["WhoDat", "WhoDatREG", "WhoDatADV"]}>
          <PreStartupForm />
        </ProtectedPage>
      ),
    },
    {
      type: "collapse",
      name: "Event Response FlowChart",
      key: "eventResponseFlowChart",
      icon: <Icon fontSize="small">warning</Icon>,
      route: "/eventResponseFlowChart",
      component: (
        <ProtectedPage allowedRoles={["WhoDat", "WhoDatREG", "WhoDatADV"]}>
          <EventResponseFlowChart />
        </ProtectedPage>
      ),
    },
    {
      route: "/authentication/sign-in",
      component: <SignIn />,
    },
    {
      type: "collapse",
      name: "Sign Out",
      key: "sign-out",
      icon: <Icon fontSize="small">logout</Icon>,
      route: "/authentication/sign-out",
      component: <SignOut />,
    }
  );

  return routes;
}

export default RoutesList;
